export const transactionTypesConstants = {
    GET_TRANSACTION_TYPE_STATS_REQUEST: 'GET_TRANSACTION_TYPE_STATS_REQUEST',
    GET_TRANSACTION_TYPE_STATS_SUCCESS: 'GET_TRANSACTION_TYPE_STATS_SUCCESS',
    GET_TRANSACTION_TYPE_STATS_FAILURE: 'GET_TRANSACTION_TYPE_STATS_FAILURE',
    CHANGE_TRANSACTION_TYPE_STATUS_REQUEST: 'CHANGE_TRANSACTION_TYPE_STATUS_REQUEST',
    CHANGE_TRANSACTION_TYPE_STATUS_SUCCESS: 'CHANGE_TRANSACTION_TYPE_STATUS_SUCCESS',
    CHANGE_TRANSACTION_TYPE_STATUS_FAILURE: 'CHANGE_TRANSACTION_TYPE_STATUS_FAILURE',
    GET_TRANSACTION_TYPES_REQUEST: 'GET_TRANSACTION_TYPES_REQUEST',
    GET_TRANSACTION_TYPES_SUCCESS: 'GET_TRANSACTION_TYPES_SUCCESS',
    GET_TRANSACTION_TYPES_FAILURE: 'GET_TRANSACTION_TYPES_FAILURE'    
}